module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2020_09.b2672309.jpg";